"use client";

import { AppState } from "@/store/store";
import { useWindowWidth } from "@react-hook/window-size";
import cn from "classnames";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import stickyHeaderStyles from "./stickyHeaderContainer.module.scss";

export type DeviceType = "mobile" | "tablet" | "desktop";

export default function StickyHeaderContainer({
  children,
  isSticky = true,
  isHomepage = false,
}: {
  children: React.ReactNode;
  isSticky?: boolean; //optional
  isHomepage?: boolean; //optional - used for z-index adjustments when search is open on homepage
}) {
  const openMenu = useSelector((state: AppState) => state.drawerMenuOpenSlice.openMenu);
  const isSearchOpen = useSelector((state: AppState) => state.searchDropdownVisibleSlice.isVisible);
  const windowWidth = useWindowWidth();
  const [deviceType, setDeviceType] = useState<DeviceType>("desktop");

  useEffect(() => {
    let newDeviceType: DeviceType;
    if (windowWidth < 576) newDeviceType = "mobile";
    else newDeviceType = "desktop";
    if (newDeviceType != deviceType) setDeviceType(newDeviceType);
  }, [windowWidth]);

  const containerClasses = cn({
    [stickyHeaderStyles.stickyHeaderContainer]: isSticky || deviceType === "mobile",
    [stickyHeaderStyles.drawerOpen]: openMenu !== "none",
    [stickyHeaderStyles.homepageSearchOpen]: isHomepage && isSearchOpen,
  });

  return <div className={containerClasses}>{children}</div>;
}
